const validationErrors = {
  ACCOUNT_NOT_FOUND: "ACCOUNT_NOT_FOUND",
  ACCOUNT_ALREADY_VERIFIED: "ACCOUNT_ALREADY_VERIFIED",
  INVALID_TOKEN: "INVALID_TOKEN"
};

export default validationErrors;
